export const GisLayerList = [
    // 0
    [
        { index: 0, checked: false,	disabled: false,	layer: 'vdsLayer',			label: 'VDS', },
        { index: 1, checked: false,	disabled: false,	layer: 'dsrcLayer',			label: 'DSRC', },
        { index: 2, checked: false,	disabled: false,	layer: 'cctvLayer',			label: 'CCTV', },
        { index: 3, checked: false,	disabled: false,	layer: 'vmsLayer',			label: 'VMS', },
        { index: 4, checked: false,	disabled: false,	layer: 'trfInfLayer',		label: '교통정보 수집현황', },
        { index: 5, checked: false,	disabled: false,	layer: 'linkLayer',			label: '도로소통정보', },
        { index: 6, checked: false,	disabled: false,	layer: 'inoutLayer',		label: '유출입', },
        { index: 7, checked: false,	disabled: false,	layer: 'parkLayer',			label: '공영주차장', },
        { index: 8, checked: false,	disabled: false,	layer: 'linkHeatLayer',		label: '도로소통히트맵', },
    ], 
    // 1
    [
        { index: 0, checked: false,	disabled: false,	layer: 'crsrLayer',			label: '스마트교차로', },
        { index: 1, checked: false,	disabled: false,	layer: 'sgnInfLayer',		label: '신호정보 개방', },
        { index: 2, checked: false,	disabled: false,	layer: 'emerLayer',			label: '긴급차량', },
        { index: 3, checked: false,	disabled: false,	layer: 'signLayer',			label: '감응 신호', },
    ],
    // 2
    [
        { index: 0, checked: false,	disabled: false,	layer: 'busLayer',			label: '버스(차량)', },
        { index: 1, checked: false,	disabled: false,	layer: 'bitLayer',			label: 'BIT', },
        { index: 2, checked: false,	disabled: false,	layer: 'busHeatLayerGetOn',	    label: '승차 인원 모니터링', },
        { index: 3, checked: false,	disabled: false,	layer: 'busHeatLayerGetOff',	label: '하차 인원 모니터링', },
        { index: 4, checked: false,	disabled: false,	layer: 'busHeatLayer',      display: 'none',    label: '승하차 인원 모니터링', },
        { index: 5, checked: false,	disabled: false,	layer: 'bisSvrStatLayer',	label: '서버 상태 현황', },      
    ],
    // 3
    [
        { index: 0, checked: false,	disabled: false,	layer: 'surfLayer',			label: '노면검지센서', },
        { index: 1, checked: false,	disabled: false,	layer: 'hazaLayer',			label: '위험물질 운송차량', },
        { index: 2, checked: false,	disabled: false,	layer: 'schoolZoneLayer',	label: '어린이보호구역', },
    ],
    // 4
    [
        { index: 0, checked: false,	disabled: false,	layer: 'selfLinkLayer',		label: '자율주행노선', },
        { index: 1, checked: false,	disabled: false,	layer: 'selfVhcLayer',		label: '자율주행차량', },
        { index: 2, checked: false, disabled: false,    layer: 'selfVhcEmulator',   label: '에뮬레이터'}
    ], 
];

export const AllLayerList = [
    // 교통
    { checked: false,	disabled: false,	layer: 'vdsLayer',			label: 'VDS', },
    { checked: false,	disabled: false,	layer: 'dsrcLayer',			label: 'DSRC', },
    { checked: false,	disabled: false,	layer: 'cctvLayer',			label: 'CCTV', },
    { checked: false,	disabled: false,	layer: 'accessCctvLayer',	label: '접근로', },
    { checked: false,	disabled: false,	layer: 'vmsLayer',			label: 'VMS', },
    { checked: false,	disabled: false,	layer: 'trfInfLayer',		label: '교통정보 수집현황', },
    { checked: false,	disabled: false,	layer: 'linkLayer',			label: '도로소통정보', },
    { checked: false,	disabled: false,	layer: 'inoutLayer',		label: '유출입', },
    { checked: false,	disabled: false,	layer: 'parkLayer',			label: '공영주차장', },
    { checked: false,	disabled: false,	layer: 'linkHeatLayer',		label: '도로소통히트맵', },
    // 신호
    { checked: false,	disabled: false,	layer: 'crsrLayer',			label: '스마트교차로', },
    { checked: false,	disabled: false,	layer: 'sgnInfLayer',		label: '신호정보 개방', },
    { checked: false,	disabled: false,	layer: 'emerLayer',			label: '긴급차량', },
    { checked: false,	disabled: false,	layer: 'signLayer',			label: '감응 신호', },
    // BIS
    { checked: false,	disabled: false,	layer: 'busLayer',			label: '버스(차량)', },
    { checked: false,	disabled: false,	layer: 'bitLayer',			label: 'BIT', },
    { checked: false,	disabled: false,	layer: 'busHeatLayerGetOn',	    label: '승차 인원 모니터링', },
    { checked: false,	disabled: false,	layer: 'busHeatLayerGetOff',	label: '하차 인원 모니터링', },
    { checked: false,	disabled: false,	layer: 'busHeatLayer',      display: 'none',    label: '승하차 인원 모니터링', },
    { checked: false,	disabled: false,	layer: 'bisSvrStatLayer',	label: '서버 상태 현황', },
    // 안전
    { checked: false,	disabled: false,	layer: 'surfLayer',			label: '노면검지센서', },
    { checked: false,	disabled: false,	layer: 'hazaLayer',			label: '위험물질 운송차량', },
    { checked: false,	disabled: false,	layer: 'schoolZoneLayer',	label: '어린이보호구역', },
    // 미래
    { checked: false,	disabled: false,	layer: 'selfLinkLayer',		label: '자율주행노선', },
    { checked: false,	disabled: false,	layer: 'selfVhcLayer',		label: '자율주행차량', },
    { checked: false,	disabled: false,	layer: 'selfVhcEmulator',		label: '에뮬레이터', },
];